module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 1
// module chunks = 0 1